import { apiClient } from "../client";

export interface Certificate {
  id: number;
  certificate_number: string;
  enrollment_id?: number;
  student_name?: string | null;
  course_title?: string | null;
  issued_at?: string | null;
  [key: string]: unknown;
}

export interface CertificateEnvelope {
  success?: boolean;
  status?: boolean;
  data: Certificate;
}

export interface VerifyCertificateResponse {
  valid: boolean;
  student_name?: string | null;
  course_title?: string | null;
  issued_at?: string | null;
  message?: string;
  [key: string]: unknown;
}

export const certificates = {
  /** Issues the certificate on-demand if the enrollment just became eligible. 404 if not yet eligible. */
  forEnrollment: (enrollmentId: number | string) =>
    apiClient.get<CertificateEnvelope>(`/enrollments/${enrollmentId}/certificate`),

  /** Public verification — no auth required. */
  verify: (certificateNumber: string) =>
    apiClient.get<VerifyCertificateResponse>(`/certificates/verify/${encodeURIComponent(certificateNumber)}`),

  /** Streams the certificate PDF — restricted to the owner/an Admin. Since
   * this is a binary download (not JSON), callers build the URL from
   * VITE_API_BASE_URL and navigate/open it directly (the BFF session cookie
   * rides along automatically) rather than calling this through apiClient. */
  downloadPath: (certificateNumber: string) =>
    `/certificates/${encodeURIComponent(certificateNumber)}/download`,
};
